/**
 * Created by evgenijsenkevic on 28.08.2024
 * */

const AdminLocation = function (bundleId) {
    cleverapps.EventEmitter.call(this);

    this.bundleId = bundleId;
    this.name = bundleId.slice("location_".length);
    this.locationId = bundles[bundleId].meta.location;
};

AdminLocation.prototype = Object.create(cleverapps.EventEmitter.prototype);
AdminLocation.prototype.constructor = AdminLocation;

AdminLocation.prototype.getBundleName = function () {
    return this.bundleId;
};

AdminLocation.prototype.getLocationId = function () {
    return this.locationId;
};

AdminLocation.prototype.getContent = function () {
    return bundles[this.getBundleName()].jsons.map_json.resolve().getJson();
};

AdminLocation.prototype.onClick = function (f) {
    cleverapps.administrator.adminLocations.setActive(this);
    f();
};

AdminLocation.prototype.select = function () {
    this.trigger("select", this);
};

AdminLocation.prototype.unselect = function () {
    this.trigger("unselect");
};